export default __webpack_public_path__ + "alberta-human-body.7873ff39def84cfc5ffd.svg";